import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { BlockBaseComponent } from "../block-base/block-base.component";
import { MatDialog } from "@angular/material/dialog";
import { TranslocoService } from "@ngneat/transloco";
import { StoreSelectorsService } from "../../../../services";
import { IButtonBar } from "../../../../components/add-remove-bar/button-bar.component";
import { ITableListColumn } from "../../../../components/table-list-input/table-list-input.component";
import { IText } from "../../../../interfaces";

@Component({
    selector: 'app-scene-block-labelqueue',
    templateUrl: './block-labelqueue.component.html',
    styleUrls: ['./block-labelqueue.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BlockLabelqueueComponent extends BlockBaseComponent {

    buttons: IButtonBar[] = [];
    tableColumns: Array<ITableListColumn> = [];

    constructor(
        private translocoService: TranslocoService,
        public override storeSelector: StoreSelectorsService,
        public override dialog: MatDialog,
        public cd: ChangeDetectorRef
    ) {
        super(storeSelector, dialog);

        this.tableColumns = [{
            inputType: 'edit',
            name: 'text',
            maxStringSize: '20'
        }, {
            inputType: 'edit',
            name: 'duration',
            maxStringSize: '10'
        }];

        this.buttons = [
            {
                callBack: v => (v),
                icon: 'add',
                name: 'add',
                disableByList: false,
                disabled: false,
                tooltip: this.translocoService.translate('general.add', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'remove',
                name: 'remove',
                confirmRemove: this.translocoService.translate('toast.deleteConfirm', {}, this.translocoService.getActiveLang()),
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.remove', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'arrow_left',
                name: 'previous',
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.next', {}, this.translocoService.getActiveLang())
            },
            {
                callBack: v => (v),
                icon: 'arrow_right',
                name: 'next',
                disableByList: true,
                disabled: false,
                tooltip: this.translocoService.translate('general.previous', {}, this.translocoService.getActiveLang())
            }
        ];
    }

    override submit(formValues) {
        this.customizeFormValues(formValues);
        super.submit(formValues);
    }

    override componentInit() {
        super.componentInit();
    }

    override componentStoreUpdates() {
        super.componentStoreUpdates();
        this.cd.detectChanges();
    }

    private customizeFormValues(formValues) {
        const pages: Array<IText> = formValues.Text.values;
        let isUpdated = false;

        if (formValues.Text?.currentAction && formValues.Text.currentAction === 'added') {
            const pager: IText = { $: { text: 'text', duration: '5' } };
            pages.push(pager);
            isUpdated = true;

        } else if (formValues.Text?.currentAction && formValues.Text.currentAction === 'selected') {
            const selectedIndex = formValues.Text.selectedIndexes[0];
            const pages: Array<IText> = formValues.Text.values;
            if (!pages[selectedIndex]?.$.duration || parseFloat(pages[selectedIndex].$.duration) <= 0) {
                pages[selectedIndex].$.duration = formValues.duration;
                isUpdated = true;
            }
        }

        if (isUpdated) {
            this.dispatchSceneItemChanges({
                sceneId: this.sceneId,
                sceneItemId: this.sceneItem.$.id,
                values: [{
                    key: 'Text',
                    value: pages,
                    storePath: 'Data[0].LabelQueue[0].TextList[0]'
                }]
            });
            super.initApplyStoreToDynamic(true);
        }
    }

    override initRegisterDynamic() {
        this.uiConfigInit = [
            {
                type: "input",
                value: '5',
                label: this.translocoService.translate('general.duration', {}, this.translocoService.getActiveLang()),
                inputType: "number",
                name: "duration",
                storePath: 'Data[0].LabelQueue[0].$.duration'
            },
            {
                type: "input",
                label: '',
                inputType: 'tablelist',
                tableColumns: this.tableColumns,
                cloneVals: true,
                multiSelect: false,
                rememberSelection: true,
                allowFilter: true,
                buttonBarClassName: 'labelqueueButtonBar',
                buttons: this.buttons,
                inputEditFormat: { text: 'text', duration: 'number' },
                inputEditRenamePath: [{ path: '$.text', key: 'text' }, { path: '$.duration', key: 'duration' }],
                name: "Text",
                allowTableOnDialog: true,
                storePath: 'Data[0].LabelQueue[0].TextList[0].Text',
                expandableEditor: true,
                // callBackEvent: (v) => this.onTableListChangeCallBack(v)
            }
            // ,{
            //     type: "checkbox",
            //     value: '1',
            //     label: this.translocoService.translate('general.gpu', {}, this.translocoService.getActiveLang()),
            //     name: "gpu",
            //     storePath: '$.gpu'
            // }
        ];
    }
}

